import { Zap } from "lucide-react";

export function Logo({ size = 36, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="relative">
        <div
          className="cv-border halftone-yellow flex items-center justify-center font-headings text-black"
          style={{ width: size, height: size, borderRadius: "50% 50% 50% 0" }}
        >
          <span style={{ fontSize: size * 0.5 }}>CV</span>
        </div>
        <Zap
          size={size * 0.45}
          className="absolute -top-1 -right-1 fill-pink-500 stroke-black"
          strokeWidth={3}
        />
      </div>
      <span className="font-headings text-2xl tracking-wide" data-testid="brand-name">
        COMIC<span className="text-purple-600">VERSE</span>
      </span>
    </div>
  );
}

export function Burst({ children, color = "#FBBF24", className = "" }) {
  return (
    <div className={`burst inline-flex items-center justify-center font-comic text-2xl ${className}`}
      style={{ background: color, padding: "20px 28px", color: "#000" }}>
      {children}
    </div>
  );
}

export function HalftoneBg({ className = "" }) {
  return <div className={`absolute inset-0 halftone opacity-50 pointer-events-none ${className}`} />;
}
